import React from 'react';
import { ReactComponent as PrimaryMarque } from '../../icons/brand/dream-marque.svg';

export type DreamMarqueVariant = 'default' | 'optical-md' | 'optical-sm';

interface DreamMarqueProps extends React.SVGProps<SVGSVGElement> {
  title?: string;
  variant?: DreamMarqueVariant;
}

const DreamMarque: React.FC<DreamMarqueProps> = ({
  variant: _variant,
  ...props
}) => <PrimaryMarque {...props} />;

export default DreamMarque;
